import cn from 'classnames';
import type { SyntheticEvent } from 'react';
import React, { useMemo } from 'react';

import { sendGeneralInfoItemClickEvent } from '@src/helpers/analyticsEvents';
import { useCard } from '@src/reducers/product';

import styles from '../../styles.module.scss';

type Props = {
    eventLabel: string;
};

export const GeneralInfo = ({ eventLabel }: Props) => {
    const { organization } = useCard();
    const registrationDate = `${new Date(organization.registrationDate).getFullYear()} год`;
    const license = organization.license === '0' ? '' : organization.license;

    const firstRowData = useMemo(
        () =>
            [
                { title: 'Полное наименование', value: organization.fullName },
                { title: 'Год основания', value: registrationDate },
                { title: 'Региональная сеть', value: organization.regionalNetwork },
                { title: 'Лицензия', value: `№ ${license}` },
            ].filter((item) => Boolean(item.value)),
        [license, organization.fullName, organization.regionalNetwork, registrationDate],
    );

    const handleItemClick = (event: SyntheticEvent, eventActionValue: string) => {
        event.stopPropagation();

        sendGeneralInfoItemClickEvent(eventLabel, eventActionValue);
    };

    return (
        <div className={cn(styles.twoColumnsWrapper, styles.oneRow)}>
            {firstRowData.map(({ title, value }) => (
                <div key={title} className={styles.cardItem}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.text} dangerouslySetInnerHTML={{ __html: value }} />
                </div>
            ))}

            {organization.contacts.phone.length && (
                <div className={styles.cardItem}>
                    <div className={styles.title}>
                        {organization.contacts.phone.length > 1 ? 'Телефоны' : 'Телефон'}
                    </div>
                    {organization.contacts.phone.map((phone) => (
                        <div key={phone} className={styles.text}>
                            {phone}
                        </div>
                    ))}
                </div>
            )}

            {organization.contacts.address && (
                <div className={styles.cardItem}>
                    <div className={styles.title}>Головной офис</div>
                    <div className={styles.text}>{organization.contacts.address}</div>
                </div>
            )}

            {organization.contacts.website && (
                <div className={styles.cardItem}>
                    <div className={styles.title}>Официальный сайт</div>
                    <a
                        onClick={(event) => handleItemClick(event, 'Официальный сайт')}
                        target="_blank"
                        href={organization.contacts.website}
                        rel="noreferrer"
                    >
                        {organization.contacts.website}
                    </a>
                </div>
            )}
        </div>
    );
};
